import { FILLABLE_ELEMENTS as trans } from './translationValues';
import { DEFAULT_FONT_FOR_LOCALISED_LANGUAGES } from '../helper';
import { FILLABLE_ELEMENTS_MAIN_CONTENT } from '../../artboard/Page/translationValues';
import { random4Characters } from '../javascript';
import { STATIC_TABLE_BLOCK } from '../complexDocumentConstants';

export const checkBoxTextElement = t => ({
  contentType: 'text',
  style: {
    width: 80.37,
    height: 20,
    x: 30,
    y: 2,
    rotate: 0,
  },
  contents: [
    {
      contentType: 'PARAGRAPH',
      style: {
        color: '#000000',
      },
      content: t(
        `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.CHECK_BOX_TEXT.key}`,
        FILLABLE_ELEMENTS_MAIN_CONTENT.CHECK_BOX_TEXT.value,
      ),
    },
    {
      contentType: 'LINE_BREAK',
      content: '\n',
      style: {
        lineSpacing: 1,
      },
    },
  ],
});

export const radioButtonTextElement = t => ({
  contentType: 'text',
  style: {
    width: 97.43,
    height: 24,
    x: 30,
    y: 2,
    rotate: 0,
  },
  contents: [
    {
      contentType: 'PARAGRAPH',
      style: {
        color: '#000000',
      },
      content: t(
        `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.RADIO_BUTTON_TEXT.key}`,
        FILLABLE_ELEMENTS_MAIN_CONTENT.RADIO_BUTTON_TEXT.value,
      ),
    },
    {
      contentType: 'LINE_BREAK',
      content: '\n',
      style: {
        lineSpacing: 1,
      },
    },
  ],
});

const radioButtonIcon = (t, currentLanguage, isStaticTableBlock) => {
  return isStaticTableBlock
    ? `<div style="display: flex; align-items: center; justify-content: flex-start;">
              <svg width="40" height="40" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
                <path d="M499 291q-56 0-104 28t-76 76-28 104 28 104 76 76 104 28 104-28 76-76 28-104-28-104-76-76-104-28zm0-208q-113 0-210 57-94 55-149 149-57 97-57 210t57 210q55 94 149 149 97 57 210 57t210-57q94-55 149-149 57-97 57-210t-57-210q-55-94-149-149-97-57-210-57zm0 749q-90 0-168-46-75-44-119-119-46-78-46-168t46-168q44-75 119-119 78-46 168-46t168 46q75 44 119 119 46 78 46 168t-46 168q-44 75-119 119-78 46-168 46z" />
              </svg>
            </div>`
    : `<div style="display: flex; align-items: center; justify-content: flex-start;">
              <svg width="22" height="22" viewBox="0 0 1000 1000" xmlns="http://www.w3.org/2000/svg">
                <path d="M499 291q-56 0-104 28t-76 76-28 104 28 104 76 76 104 28 104-28 76-76 28-104-28-104-76-76-104-28zm0-208q-113 0-210 57-94 55-149 149-57 97-57 210t57 210q55 94 149 149 97 57 210 57t210-57q94-55 149-149 57-97 57-210t-57-210q-55-94-149-149-97-57-210-57zm0 749q-90 0-168-46-75-44-119-119-46-78-46-168t46-168q44-75 119-119 78-46 168-46t168 46q75 44 119 119 46 78 46 168t-46 168q-44 75-119 119-78 46-168 46z" />
              </svg>
              <p class="fillableThumbnail" style="margin-left: 2px; font-family: ${DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(
                currentLanguage,
              )}; font-size: 16px; line-height: 1em;">${t(
        `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.RADIO_BUTTON_TEXT.key}`,
        FILLABLE_ELEMENTS_MAIN_CONTENT.RADIO_BUTTON_TEXT.value,
      )}</p>
            </div>`;
};

const checkBoxIcon = (t, currentLanguage, isStaticTableBlock) => {
  return isStaticTableBlock
    ? `<div style="display: flex; align-items: center; justify-content: center;">
         <svg
           width="40"
           height="40"
           viewBox="0 0 22 22"
           xmlns="http://www.w3.org/2000/svg"
           xmlnsXlink="http://www.w3.org/1999/xlink"
         >
           <g
             id="Free-Icons"
             stroke="none"
             strokeWidth={1}
             fill="none"
             fillRule="evenodd"
             strokeLinecap="round"
             strokeLinejoin="round"
           >
             <g
               transform="translate(-747.000000, -526.000000)"
               id="Group"
               stroke="#000000"
               strokeWidth={2}
             >
               <g transform="translate(745.000000, 524.000000)" id="Shape">
                 <path d="M5.16000009,3 L18.8399999,3 C20.032935,3 21,3.96706498 21,5.16000009 L21,18.8399999 C21,20.032935 20.032935,21 18.8399999,21 L5.16000009,21 C3.96706498,21 3,20.032935 3,18.8399999 L3,5.16000009 C3,3.96706498 3.96706498,3 5.16000009,3 Z" />
                 <polyline points="7 11.5593959 11.1176466 15.5 17 8.5" />
               </g>
             </g>
           </g>
         </svg>
       </div>`
    : `<div style="display: flex; align-items: center; justify-content: center;">
         <svg
           width="22"
           height="22"
           viewBox="0 0 22 22"
           xmlns="http://www.w3.org/2000/svg"
           xmlnsXlink="http://www.w3.org/1999/xlink"
         >
           <g
             id="Free-Icons"
             stroke="none"
             strokeWidth={1}
             fill="none"
             fillRule="evenodd"
             strokeLinecap="round"
             strokeLinejoin="round"
           >
             <g
               transform="translate(-747.000000, -526.000000)"
               id="Group"
               stroke="#000000"
               strokeWidth={2}
             >
               <g transform="translate(745.000000, 524.000000)" id="Shape">
                 <path d="M5.16000009,3 L18.8399999,3 C20.032935,3 21,3.96706498 21,5.16000009 L21,18.8399999 C21,20.032935 20.032935,21 18.8399999,21 L5.16000009,21 C3.96706498,21 3,20.032935 3,18.8399999 L3,5.16000009 C3,3.96706498 3.96706498,3 5.16000009,3 Z" />
                 <polyline points="7 11.5593959 11.1176466 15.5 17 8.5" />
               </g>
             </g>
           </g>
         </svg>
         <p class="fillableThumbnail" style="margin-left: 2px; font-family: ${DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(
           currentLanguage,
         )}; font-size: 16px; line-height: 1em;">${t(
        `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.CHECK_BOX_TEXT.key}`,
        FILLABLE_ELEMENTS_MAIN_CONTENT.CHECK_BOX_TEXT.value,
      )}</p>
       </div>
     `;
};

export const fillableElements = (t, currentLanguage = 'en', currentBlockType) => {
  const isStaticTableBlock = currentBlockType === STATIC_TABLE_BLOCK;
  const elements = [
    {
      id: 295,
      type: 'block',
      categoryId: 188,
      shareType: null,
      isFillable: true,
      thumbnail: t(
        `FILLABLE_ELEMENTS:${trans.SIGNATURE_THUMBNAIL.key}`,
        trans.SIGNATURE_THUMBNAIL.value,
      ),
      name: t(`FILLABLE_ELEMENTS:${trans.SIGNATURE_LABEL.key}`, trans.SIGNATURE_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        uiType: 'signature',
        type: 'signature',
        styles: {
          border: 'rgb(0, 0, 0)',
          transform: 'translateX(154.975px) translateY(152.228px) rotate(0deg) ',
          background: 'rgb(255, 255, 255)',
          width: '422px',
          position: 'absolute',
          height: '157px',
        },
        additionalStyles: {
          border: {
            borderColor: '#000000'
          },
          backgroundColor: '#ffffff'
        },
        tagName: 'signature',
        formOptions: {
          fieldName: `signature-1${random4Characters()}`,
        },
        content: t(`FILLABLE_ELEMENTS:${trans.SIGNATURE_LABEL.key}`, trans.SIGNATURE_LABEL.value),
        formField: {
          fieldName: 'signature',
          name: 'null',
          checked: true,
          readOnly: false,
          isVariable: false,
          required: false,
        },
        tagStyles: {
          rotate: 0,
          backgroundColor: [255, 255, 255],
          borderColor: [0, 0, 0],
          color: [0, 0, 0],
          size: 16,
          translateY: 152.228,
          translateX: 154.975,
          width: 422,
          alignment: 'left',
          family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
          lineSpacing: 1.5,
          height: 157,
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 294,
      type: 'block',
      categoryId: 188,
      shareType: null,
      isFillable: true,
      /*thumbnail: t(
        `FILLABLE_ELEMENTS:${trans.RADIO_BUTTON_THUMBNAIL.key}`,
        trans.RADIO_BUTTON_THUMBNAIL.value,
      ),*/
      thumbnail: radioButtonIcon(t, currentLanguage, isStaticTableBlock),
      name: t(`FILLABLE_ELEMENTS:${trans.RADIO_BUTTON_LABEL.key}`, trans.RADIO_BUTTON_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        type: 'radiobutton',
        styles: {
          scaleX: 1,
          rotate: 0,
          scaleY: 1,
          translateY: 225.285,
          translateX: 209.966,
          x : 0,
          y : 0,
          width: '22',
          height: '22px',
          position: 'absolute',
        },
        additionalStyles: {
          color: '#000000',
          border : { borderColor : "#000000" },
          backgroundColor : "#ffffff",
          isVariable: false
        },
        formOptions : {
          groupName : `radio-group-1${random4Characters()}`,
          fieldName : `radio-button-1${random4Characters()}`,
          isReadOnly : false,
          isChecked: true
        },
        // tagName: 'radiobuttongroup',
        contents : [
        {
            contentType : "radiobutton",
            content : "true",
            formOptions : {
              fieldName : "radio-button-1",
              isReadOnly : false
            },
            style:
            {
                x : 0,
                y : 0,
                width : 22,
                height : 22,
            }
        },
        radioButtonTextElement(t)],
        formField: {
          checkType: '4',
          formElementDetails: [
            {
              tagName: 'radiobutton',
              formField: {
                checkType: '4',
                fieldName: 'radio-button-1',
                formElementType: 'radiobutton',
                checked: true,
                isVariable: false,
                readOnly: false,
              },
              tagStyles: {
                rotate: 0,
                backgroundColor: [255, 255, 255],
                borderColor: [0, 0, 0],
                color: [0, 0, 0],
                translateY: 225.285,
                translateX: 209.966,
                width: 22,
                'border-color': 'rgb(0, 0, 0)',
                height: 22,
              },
            },
            {
              text: [
                {
                  backgroundColor: [0, 0, 0, 0],
                  underLined: false,
                  color: [0, 0, 0],
                  size: 16,
                  textValue: t(
                    `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.RADIO_BUTTON_TEXT.key}`,
                    FILLABLE_ELEMENTS_MAIN_CONTENT.RADIO_BUTTON_TEXT.value,
                  ),
                  variableDetails: {
                    isVariable: false,
                  },
                  letterSpacing: 0,
                  bold: false,
                  family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                  italic: false,
                },
              ],
              tagName: 'paragraph',
              formField: {
                checkType: '4',
                fieldName: 'radio-button-1',
                formElementType: 'radiobutton',
                isVariable: false,
                readOnly: false,
              },
              tagStyles: {
                rotate: 0,
                backgroundColor: [0, 0, 0, 0],
                color: [0, 0, 0],
                size: 16,
                translateY: 225.285,
                translateX: 233.41410000000002,
                width: 97.43,
                letterSpacing: 0,
                alignment: 'left',
                family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                lineSpacing: 1,
                height: 24,
              },
            },
          ],
          fieldName: 'radio-group-1',
          formElementType: 'radiobutton',
          isVariable: false,
          readOnly: false,
        },
        tagStyles: {
          scaleX: 1,
          rotate: 0,
          scaleY: 1,
          backgroundColor: [255, 255, 255],
          translateY: 225.285,
          translateX: 209.966,
          width: 121.43,
          height: 24,
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 293,
      type: 'block',
      categoryId: 188,
      shareType: null,
      isFillable: true,
      /*thumbnail: t(
        `FILLABLE_ELEMENTS:${trans.CHECK_BOX_THUMBNAIL.key}`,
        trans.CHECK_BOX_THUMBNAIL.value,
      ),*/
      thumbnail: checkBoxIcon(t, currentLanguage, isStaticTableBlock),
      name: t(`FILLABLE_ELEMENTS:${trans.CHECK_BOX_LABEL.key}`, trans.CHECK_BOX_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        type: 'checkbox',
        styles: {
          scaleX: 1,
          rotate: 0,
          scaleY: 1,
          x : 0,
          y : 0,
          translateY: 225.285,
          translateX: 209.966,
          width: '112.37px',
          height: '24px',
          position: 'absolute'
        },
        formOptions : {
          groupName: `checkbox-group-1${random4Characters()}`,
          fieldName : `check-box-1${random4Characters()}`,
          checkType : "4",
          isReadOnly : false,
          isChecked: true,
          /*fieldName : "check-box-group-1",
          checkStyle : "4",
          isReadOnly : false,
          direction : "vertical",
          size: 22,
          textIndent: 2,
          outerSpace: 2,
          verticalAlignment: 'top',
          textStyles: {},
          boxStyles: {
            border : { borderColor : "#000000" },
            backgroundColor : "#000000",
          }*/
        },
        additionalStyles: {
          isVariable: false,
          width : "22px",
          height : "22px",
          border : { borderColor : "#000000" },
          backgroundColor : "#ffffff",
          color: "#000000"
        },
        contents : [
        {
            contentType : "checkbox",
            content : "true",
            formOptions : {
              fieldName : "check-box-1",
              checkStyle : "4",
              isReadOnly : false,
              isVariable: false,
            },
            style:
            {
                x : 0,
                y : 0,
                width : 22,
                height : 22,
            }
        },
        checkBoxTextElement(t)],
        formField: {
          checkType: '4',
          formElementDetails: [
            {
              tagName: 'checkbox',
              formField: {
                checkType: '4',
                fieldName: 'check-box-1',
                formElementType: 'checkbox',
                checked: true,
                isVariable: false,
                readOnly: false,
              },
              tagStyles: {
                rotate: 0,
                backgroundColor: [255, 255, 255],
                borderColor: [0, 0, 0],
                color: [0, 0, 0],
                translateY: 227.285,
                translateX: 209.966,
                width: 22,
                'border-color': 'rgb(0, 0, 0)',
                height: 22,
              },
            },
            {
              text: [
                {
                  backgroundColor: [0, 0, 0, 0],
                  underLined: false,
                  color: [0, 0, 0],
                  size: 16,
                  textValue: t(
                    `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.CHECK_BOX_TEXT.key}`,
                    FILLABLE_ELEMENTS_MAIN_CONTENT.CHECK_BOX_TEXT.value,
                  ),
                  variableDetails: {
                    isVariable: false,
                  },
                  letterSpacing: 0,
                  bold: false,
                  family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                  italic: false,
                },
              ],
              tagName: 'paragraph',
              formField: {
                checkType: '4',
                fieldName: 'check-box-1',
                formElementType: 'checkbox',
                isVariable: false,
                readOnly: false,
              },
              tagStyles: {
                rotate: 0,
                backgroundColor: [0, 0, 0, 0],
                color: [0, 0, 0],
                size: 16,
                translateY: 225.285,
                translateX: 233.966,
                width: 80.37,
                letterSpacing: 0,
                alignment: 'left',
                family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                lineSpacing: 1,
                height: 24,
              },
            },
          ],
          fieldName: 'check-box-group-1',
          formElementType: 'checkbox',
          isVariable: false,
          readOnly: false,
        },
        tagStyles: {
          scaleX: 1,
          rotate: 0,
          scaleY: 1,
          backgroundColor: [255, 255, 255],
          translateY: 225.285,
          translateX: 209.966,
          width: 107.37,
          height: 24,
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 292, // TODO : Remove any ids or keys not needed in front end
      type: 'block',
      categoryId: 188,
      shareType: null,
      isFillable: true,
      thumbnail: t(
        `FILLABLE_ELEMENTS:${trans.TEXT_BOX_THUMBNAIL.key}`,
        trans.TEXT_BOX_THUMBNAIL.value,
      ),
      name: t(`FILLABLE_ELEMENTS:${trans.TEXT_BOX_LABEL.key}`, trans.TEXT_BOX_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        uiType: 'textbox',
        type: 'textbox', // TODO : Check for regression in document design area due to changes made in here
        styles: {
          scaleX: 1,
          rotate: 0,
          scaleY: 1,
          translateY: 56.4386,
          translateX: 91.6192,
          width: '250px',
          height: '26px',
          position: 'absolute'
        },
        additionalStyles: {
          border: {
            borderColor: '#cccccc',
            thickness: 0
          },
          backgroundColor: '#e7e5e5'
        },
        tagName: 'textbox',
        formOptions :
      	{
      	  fieldName: `text-box-1${random4Characters()}`,
      		isMultiLine : false,
      		isReadOnly : false,
      		maxCharacters : 250
      	},
      	contents :
      	[
      	{
      		contentType : "PARAGRAPH",
      		content : t(
              `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.TEXT_BOX_TEXT.key}`,
              FILLABLE_ELEMENTS_MAIN_CONTENT.TEXT_BOX_TEXT.value,
            ),
            style: {
              fontSize: 14,
              color: '#000000'
            }
      	},
      	{
            contentType : "LINE_BREAK",
            content: "\n",
            style: {
              fontSize: 14,
              lineSpacing: 1.5
            }
      	}
      	],
        formField: {
          fieldName: 'text-box-1',
          formElementType: 'textbox',
          multiline: false,
          scroll: false,
          passwordField: false,
          readOnly: false,
          maxLength: 250,
          placeHolder: {
            text: [
              {
                backgroundColor: [0, 0, 0, 0],
                color: [0, 0, 0],
                size: 14,
                textValue: t(
                  `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.TEXT_BOX_TEXT.key}`,
                  FILLABLE_ELEMENTS_MAIN_CONTENT.TEXT_BOX_TEXT.value,
                ),
                underLined: false,
                variableDetails: {
                  isVariable: false,
                },
                letterSpacing: 0,
                bold: false,
                family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                italic: false,
              },
            ],
            tagName: 'paragraph',
            tagStyles: {
              border: '2px solid rgb(204, 204, 204)',
              rotate: 0,
              backgroundColor: [231, 229, 229],
              borderColor: [204, 204, 204],
              'z-index': '0',
              color: [0, 0, 0],
              letterSpacing: 0,
              lineSpacing: 1.5,
              scaleX: 1,
              scaleY: 1,
              size: 14,
              translateY: 56.4386,
              translateX: 91.6192,
              width: 250,
              alignment: 'left',
              family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage), // TODO : This has to be localized - Check with Thaya
              height: 26,
            },
          },
          required: false,
        },
        tagStyles: {
          rotate: 0,
          backgroundColor: [231, 229, 229],
          borderColor: [204, 204, 204],
          'z-index': '0',
          color: [0, 0, 0],
          letterSpacing: 0,
          lineSpacing: 1.5,
          scaleX: 1,
          scaleY: 1,
          size: 14,
          translateY: 56.4386,
          translateX: 91.6192,
          width: 250,
          alignment: 'left',
          family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
          height: 26,
        },
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
    {
      id: 273,
      type: 'block',
      categoryId: 129,
      shareType: null,
      isFillable: true,
      thumbnail: t(
        `FILLABLE_ELEMENTS:${trans.COMBO_BOX_THUMBNAIL.key}`,
        trans.COMBO_BOX_THUMBNAIL.value,
      ),
      name: t(`FILLABLE_ELEMENTS:${trans.COMBO_BOX_LABEL.key}`, trans.COMBO_BOX_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        styles: {
          transform:
            'translateX(171.345)\n          translateY(86.9918px) rotate(0px) scaleX(1px) scaleY(1px)',
          color: [0, 0, 0],
          background: [255, 255, 255],
          width: '189.438px',
          height: '23.9375px',
          position: 'absolute'
        },
        blockElements: [
          {
            uiType: 'combobox',
            tagName: 'combobox',
            formField: {
              formElementDetails: [
                {
                  text: [
                    {
                      backgroundColor: [0, 0, 0, 0],
                      borderColor: [204, 204, 204, 1],
                      underLined: false,
                      color: [0, 0, 0],
                      size: 14,
                      textValue: t(
                        `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.COMBO_BOX_TEXT.key}`,
                        FILLABLE_ELEMENTS_MAIN_CONTENT.COMBO_BOX_TEXT.value,
                      ),
                      variableDetails: {
                        isVariable: false,
                      },
                      letterSpacing: 0,
                      bold: false,
                      family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                      italic: false,
                    },
                  ],
                  tagName: 'paragraph',
                  formField: {
                    checkType: '4',
                    fieldName: 'combobox-1',
                    formElementType: 'combobox',
                    isVariable: false,
                    readOnly: false,
                    direction: 'vertical',
                  },
                  tagStyles: {
                    rotate: 0,
                    backgroundColor: [0, 0, 0, 0],
                    borderColor: [204, 204, 204, 1],
                    color: [0, 0, 0],
                    letterSpacing: 0,
                    lineSpacing: 1.5,
                    size: 14,
                    translateY: 44.7978,
                    translateX: 131.5281,
                    width: 157,
                    alignment: 'left',
                    family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                    height: 24,
                  },
                },
                {
                  text: [
                    {
                      backgroundColor: [0, 0, 0, 0],
                      borderColor: [204, 204, 204, 1],
                      underLined: false,
                      color: [0, 0, 0],
                      size: 14,
                      textValue: 'Value2',
                      variableDetails: {
                        isVariable: false,
                      },
                      letterSpacing: 0,
                      bold: false,
                      family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                      italic: false,
                    },
                  ],
                  tagName: 'paragraph',
                  formField: {
                    checkType: '4',
                    fieldName: 'combobox-1',
                    formElementType: 'combobox',
                    isVariable: false,
                    readOnly: false,
                    direction: 'vertical',
                  },
                  tagStyles: {
                    rotate: 0,
                    backgroundColor: [0, 0, 0, 0],
                    borderColor: [204, 204, 204, 1],
                    color: [0, 0, 0],
                    letterSpacing: 0,
                    lineSpacing: 1.5,
                    size: 14,
                    translateY: 44.7978,
                    translateX: 131.5281,
                    width: 157,
                    alignment: 'left',
                    family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
                    height: 24,
                  },
                },
              ],
              fieldName: 'combobox-1',
              formElementType: 'combobox',
              isVariable: false,
            },
            calculatedStyles: {
              '': 0,
              scaleX: 1,
              rotate: 0,
              scaleY: 1,
              translateY: 86.9918,
              translateX: 171.345,
            },
            tagStyles: {
              border: '1px solid rgb(204, 204, 204)',
              rotate: 0,
              backgroundColor: [255, 255, 255],
              'z-index': '0',
              borderColor: [204, 204, 204],
              color: [0, 0, 0],
              scaleX: 1,
              scaleY: 1,
              outline: 'none',
              size: 14,
              translateY: 86.9918,
              translateX: 171.345,
              width: 189.438,
              family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
              height: 23.9375,
            },
          },
        ],
        tagName: 'combobox',
        tagStyles: {
          scaleX: 1,
          scaleY: 1,
          rotate: 0,
          backgroundColor: [255, 255, 255, 1],
          borderColor: [204, 204, 204, 1],
          color: [0, 0, 0],
          size: 14,
          translateY: 86.99179077148438,
          translateX: 171.344970703125,
          width: 189.4375,
          family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
          height: 23.9375,
        },
        styles: {
          scaleX: 1,
          rotate: 0,
          scaleY: 1,
          translateY: 86.99179077148438,
          translateX: 171.344970703125,
          width: '189.4375px',
          height: '24px',
          position: 'absolute',
          family: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
          size: 14,
        },
        additionalStyles: {
          border: {
            borderColor: '#cccccc'
          },
          backgroundColor: '#e7e5e5',
          color : "#000000",
          fontSize: 14,
          fontFamily: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
          isVariable: false        
        },
        formOptions: {
          fieldName: `combobox-1${random4Characters()}`,
        },
        contents: [
          {
            contentType: 'COMBO_BOX',
            content: [
              {
                contentType: 'PARAGRAPH',
                content: `${t(
                  `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.COMBO_BOX_TEXT.key}`,
                  FILLABLE_ELEMENTS_MAIN_CONTENT.COMBO_BOX_TEXT.value,
                )} 1`,
                style: {
                  fontSize: 14,
                  color: '#000000',
                },
              },
              {
                contentType: 'LINE_BREAK',
                content: '\n',
                style: {
                  fontSize: 14,
                  lineSpacing: 1.5,
                },
              },
            ],
            defaultValue: false
          },
          {
            contentType: 'COMBO_BOX',
            content: [
              {
                contentType: 'PARAGRAPH',
                content: `${t(
                  `FILLABLE_ELEMENTS_MAIN_CONTENT:${FILLABLE_ELEMENTS_MAIN_CONTENT.COMBO_BOX_TEXT.key}`,
                  FILLABLE_ELEMENTS_MAIN_CONTENT.COMBO_BOX_TEXT.value,
                )} 2`,
                style: {
                  fontSize: 14,
                  color: '#000000',
                },
              },
              {
                contentType: 'LINE_BREAK',
                content: '\n',
                style: {
                  fontSize: 14,
                  lineSpacing: 1.5,
                },
              },
            ],
            defaultValue: false
          },
        ],  
        type: 'combobox',      
      },
      groupId: null,
      language: null,
      elementJson: {
        empty: false,
      },
    },
  ];

  if (isStaticTableBlock) {
    elements.push({
      id: 274,
      type: 'block',
      categoryId: 188,
      shareType: null,
      isFillable: true,
      thumbnail: checkBoxIcon(t, currentLanguage),
      name: t(`FILLABLE_ELEMENTS:${trans.CHECKBOX_GROUP_LABEL.key}`, trans.CHECKBOX_GROUP_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        fillableType: 'checkboxgroup', // different type for fully dynamic
        contentType: 'fillable',
        style: {
          // Along with text block styles
          width: 100, // Complete text box width
          height: 100, // Not mandatory , It will exceed
          backgroundColor: '#ffffff',
          color: '#000000',
          fontFamily: 'Open Sans', //Content style
          fontSize: 20,
        },
        contents: {
          contentType: 'fillable',
          style: {
            width: 22,
            height: 22,
            border: {
              borderColor: '#000000',
            },
            backgroundColor: '#ffffff',
            color: '#000000',
          },
          fillableType: 'checkbox',
          formOptions: {
            groupName: `checkbox-group-1${random4Characters()}`,
            checkStyle: '4',
            isReadOnly: false,
            direction: 'vertical', // mandatory
          },
        },
        type: 'checkboxgroup',
      },
    });

    elements.push({
      id: 275,
      type: 'block',
      categoryId: 189,
      shareType: null,
      isFillable: true,
      thumbnail: radioButtonIcon(t, currentLanguage),
      // name: t(`FILLABLE_ELEMENTS:${trans.COMBO_BOX_LABEL.key}`, trans.COMBO_BOX_LABEL.value),
      name: t(`FILLABLE_ELEMENTS:${trans.RADIOBUTTON_GROUP_LABEL.key}`, trans.RADIOBUTTON_GROUP_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        fillableType: 'radiobuttongroup', // different type for fully dynamic
        contentType: 'fillable',
        style: {
          // Along with text block styles
          width: 100, // Complete text box width
          height: 100, // Not mandatory , It will exceed
          backgroundColor: '#ffffff',
          color: '#000000',
          fontFamily: 'Open Sans', //Content style
          fontSize: 20,
        },
        contents: {
          contentType: 'fillable',
          style: {
            width: 22,
            height: 22,
            border: {
              borderColor: '#000000',
            },
            backgroundColor: '#ffffff',
            color: '#000000',
          },
          fillableType: 'radiobutton',
          formOptions: {
            groupName: `radiobutton-group-1${random4Characters()}`,
            isReadOnly: false,
            direction: 'vertical', // mandatory
          },
        },
        type: 'radiobuttongroup',
      }
    });
    elements.push({
      id: 276,
      type: 'block',
      categoryId: 190,
      shareType: null,
      isFillable: true,
      thumbnail: t(
        `FILLABLE_ELEMENTS:${trans.COMBO_BOX_THUMBNAIL.key}`,
        trans.COMBO_BOX_THUMBNAIL.value,
      ),
      name: t(`FILLABLE_ELEMENTS:${trans.COMBOBOX_GROUP_LABEL.key}`, trans.COMBOBOX_GROUP_LABEL.value),
      tags: null,
      resourceGroup: 0,
      permission: 'write',
      referenced: false,
      element: {
        contentType: 'fillable',
        fillableType: 'combobox_group', // Different type
        blockElements: [],
        style: {
          width: 189.4375,
          height: 24,
          border: {
            borderColor: '#cccccc',
          },
          backgroundColor: '#e7e5e5',
          color: '#000000',
          fontSize: 14,
          fontFamily: DEFAULT_FONT_FOR_LOCALISED_LANGUAGES(currentLanguage),
          isVariable: true, // Always true
        },
        formOptions: {
          fieldName: `combobox-group-1${random4Characters()}`,
        },
        contents: null,
        type: 'combobox_group',
      },
    });
  }
  return elements;
};
